import React from 'react'
import { t } from '../../../utilities/translator'
import { pushEvent } from '../../../utilities/analytics'
import { WIZARD_HINT_CLICKED } from '../../../constants/analyticEvents'

const PromptHints = ({
  onSelect,
}) => {
  const prompts = []

  if (t('onboarding.assistant.promptShort1').length > 0) {
    prompts.push({
      short: t('onboarding.assistant.promptShort1'),
      long: t('onboarding.assistant.promptLong1'),
      type: t('onboarding.assistant.promptType1'),
    })
  }
  if (t('onboarding.assistant.promptShort2').length > 0) {
    prompts.push({
      short: t('onboarding.assistant.promptShort2'),
      long: t('onboarding.assistant.promptLong2'),
      type: t('onboarding.assistant.promptType2'),
    })
  }
  if (t('onboarding.assistant.promptShort3').length > 0) {
    prompts.push({
      short: t('onboarding.assistant.promptShort3'),
      long: t('onboarding.assistant.promptLong3'),
      type: t('onboarding.assistant.promptType3'),
    })
  }

  const handlePromptClick = (prompt, index) => {
    onSelect(prompt);
    pushEvent(WIZARD_HINT_CLICKED, {
      prompt,
      number: index + 1,
    })
  }

  return (
    <div className="hints-list shrink-0">
      {prompts.map((prompt, index) => (
        <div key={index} className="hint-item text-start" onClick={() => handlePromptClick(prompt.long, index)}>
          <span>{prompt.short}</span>
          <span className="hint-item__theme">{prompt.type}</span>
        </div>
      ))}
    </div>
  )
}

export default PromptHints
